// Vite entry — mounts <App /> and kicks off PWA service-worker registration.
// Real screens live under sibling per-component folders (src/App, src/Home, …).
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { registerSW } from '@/pwa'
import { getServerEnv } from '@/lib/baseUrl'
import './i18n' // i18n init — must run before App renders
// Brand palette (--syn-* greens / ink / identity). Before index.css so the
// app's semantic tokens layer on top of the shared brand defaults.
import '@synvya/portal-ui/css/brand-tokens.css'
// Measure tones (--trend-* / --series-* / --notice-*) — what a report uses to
// say whether a number is doing well. Beside the brand palette for the same
// reason: index.css layers on top.
import '@synvya/portal-ui/css/measure-tokens.css'
// Kind colours, which venue-ui's section badges read.
import '@synvya/portal-ui/css/kind-tokens.css'
// Surface tokens (--background / --card / --border and the rest of the
// shadcn-style set, light and dark). One owner, so index.css defines none.
import '@synvya/portal-ui/css/surface-tokens.css'
// Spacing scale (gaps and hit sizes) the dish editor and choice rows read.
import '@synvya/portal-ui/css/spacing-tokens.css'
import './index.css'
import '@synvya/venue-ui/css/venue-ui.css'
import '@synvya/portal-ui/css/legal-prose.css'
import '@synvya/portal-ui/css/safe-area.css'
// Applies the saved Text Size to the root font-size on load (the portal-ui
// text-size module boot-applies on import), before first paint.
import '@synvya/portal-ui/text-size'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element — check index.html')

// **Refuse to start on a mismatched environment.** getServerEnv throws when
// VITE_APP_ENV names a different deployment than VITE_SERVER_BASE_URL points
// at. Checking here rather than at first use is deliberate: the only caller is
// the provisioning auto-heal, which swallows every exception, so a mismatch
// would register restaurants under the wrong label and report nothing.
getServerEnv()

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerSW()
